export const getDownloadUrlForDocument = (relativePath) => {
  return `${process.env.REACT_APP_WISHMAKER_API_URI}/public/storage/${relativePath}`;
};
